import { render, staticRenderFns } from "./form-auto.vue?vue&type=template&id=58965973&"
import script from "./form-auto.vue?vue&type=script&lang=js&"
export * from "./form-auto.vue?vue&type=script&lang=js&"
import style0 from "./form-auto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports